
<template>
     <div>
    <section style="background-color: rgba(156, 179, 189, 0.2); padding: 40px;">
        <div style="text-align: center;">
        <h2 style="margin-bottom: 0; font-size: 40px; font-weight: bold;">{{ block.title }}</h2>
        <img src="/img/teal-line.svg" class="mb20 mt20"/>
    </div>
    <div class="fort-body">
        
        <div v-html="block.IntroBody" v-if="block.IntroBody"></div>
        <div style="text-align: center;">
        <img :src="'https://news.spacesaver.com' + block.IntroImage.url" v-if="block.IntroImage" class="news-image"/>
    </div>
        <div v-html="block.TeamBody" v-if="block.TeamBody"></div>

        <div v-if="block.TeamMember">
<div v-for="person in block.TeamMember" style="display: flex; justify-content: center; align-items: center; margin-bottom: 20px;">
   <div>
    <img :src="'https://news.spacesaver.com' + person.Headshot.url" style="max-width: 100px;" class="circle-image"/>
    </div>
    <div id="personBody" v-html="person.body" style="margin-left: 20px;"></div>
</div>
        </div>
        <div v-html="block.body">

</div>
</div>
    </section>
   
   <divider v-if="block.BottomDivider" />
  </div>
</template>
  
  <script>
  import Divider from "@/components/FortBuilder/Divider.vue";

export default {
  name: "NewsToKnow",
  data() {
    return {};
  },
  props: {
      block: {
        type: Object,
        required: true,
      },
  },
  components: {
    Divider,
  },
};
</script>

  <style>
  #personBody p {
    margin-bottom: 0!important;
  }
  .news-image{
    width: 80%!important;
    margin: 20px 0 40px;
  }
  @media all and (max-width: 1199px) {
    .news-image{
        width: 100%!important;
        margin: 20px 0 40px;
    }
  }
  .circle-image {
    width: 100px; /* Set desired width */
    height: 100px; /* Set desired height, must match width for a perfect circle */
    object-fit: cover; /* Ensures the image fills the circle without distortion */
    border-radius: 50%; /* Creates the circular shape */
    overflow: hidden; /* Clips any content outside the circle */
}
</style>















